import {createDataStore} from '@shared_web/lib/data_store';
import {createTheme} from '@shared_web/theme/theme_base';
import {FrontendTheme} from '@shared_web/theme/theme_model';

const appThemeStore = createDataStore<FrontendTheme>(createTheme({accentColor: '#224064'}));
export const getAppTheme = appThemeStore.getData;
export const setAppTheme = appThemeStore.setData;
export const useAppTheme = appThemeStore.useData;
